<template>
  <img
  src="../assets/loading_colorful.gif"
  style="{
    width: 100px;
    height: 100px;
    margin:auto;
    left:0;
    right:0;
    top:0;
    bottom:0;
    position:fixed;
    z-index: 100
  }"
  v-show="waiting"
  />
</template>

<script>
export default {
  props: [
    'waiting'
  ]
}
</script>
